// extracted by mini-css-extract-plugin
export default {"tit":"index_tit_-TMRn","txt":"index_txt_PlQ7H"};